module.exports = __webpack_public_path__ + "static/media/Inter-ExtraLightItalic.65837db5.woff";